import React from "react";
import "../assets/css/Shapes.scss";

import { ReactComponent as IconLineArrow } from '../assets/icons/custom/Arrow.svg'
import { ReactComponent as IconCircle } from '../assets/icons/shape/Circle.svg'
import { ReactComponent as IconLine } from '../assets/icons/shape/Line.svg'
import { ReactComponent as IconRectangle } from '../assets/icons/shape/Rectangle.svg'
import { ReactComponent as IconTriangle } from '../assets/icons/shape/Triangle.svg'
import { ReactComponent as IconTwoSidedLineArrow } from '../assets/icons/custom/arrowleftright.svg'
import { ReactComponent as IconAreaSelection } from '../assets/icons/shape/AreaSelection.svg'
import { ReactComponent as IconTwoPointSelection } from '../assets/icons/shape/TwoPointSelection.svg'

const Shapes = ({
                    canvas,
                    setActiveShape,
                    setActiveTool,
                    activeTool,
                    changeActiveTool,
                    setActiveLine,
                    activeDropdown,
                    setIsActiveDropdown
                }) => {
    const handleShapeAdd = (e, selectedShape) => {
        changeActiveTool(selectedShape, true);
        setIsActiveDropdown(false);
        if (activeDropdown === "lines") {
            setActiveLine(selectedShape);
        }
        if (activeDropdown === "shapes") {
            setActiveShape(selectedShape);
        }

        // if (selectedShape === 'line') {
        //     setActiveTool('line')
        //     return
        // }
        // fabric.loadSVGFromString(
        //     e.currentTarget.children[0].outerHTML,
        //     (objects, options) => {
        //         var obj = fabric.util.groupSVGElements(objects, options)
        //         obj.strokeUniform = true
        //         obj.strokeLineJoin = 'miter'
        //         obj.scaleToWidth(100)
        //         obj.scaleToHeight(100)
        //         obj.set({ left: 0, top: 0 })
        //         canvas.add(obj).requestRenderAll()
        //         canvas.calcOffset()
        //         canvas.fire('object:modified')
        //     }
        // )
    };
    //  console.log('activeTool:', activeTool)
    return (
        <div className="toolpanel visible shapeToolPanel">
            <div className="holder sbar">
                {activeDropdown === "shapes" && (
                    <div className="shapes">
                        <div
                            className={`button ${
                                activeTool === "rectangle" ? "active" : ""
                            }`}
                            onClick={(e) => handleShapeAdd(e, "rectangle")}
                        >
                            <IconRectangle />
                        </div>
                        <div
                            className={`button ${
                                activeTool === "circle" ? "active" : ""
                            }`}
                            onClick={(e) => handleShapeAdd(e, "circle")}
                        >
                            <IconCircle />
                        </div>
                        <div
                            className={`button ${
                                activeTool === "triangle" ? "active" : ""
                            }`}
                            onClick={(e) => handleShapeAdd(e, "triangle")}
                        >
                            <IconTriangle />
                        </div>
                    </div>
                )}
                {activeDropdown === "lines" && (
                    <div className="shapes">
                        <div
                            className={`button ${
                                activeTool === "lineArrow" ? "active" : ""
                            }`}
                            onClick={(e) => handleShapeAdd(e, "lineArrow")}
                        >
                            <IconLineArrow />
                        </div>
                        <div
                            className={`button ${
                                activeTool === "lineArrowLeftRight"
                                    ? "active"
                                    : ""
                            }`}
                            onClick={(e) =>
                                handleShapeAdd(e, "lineArrowLeftRight")
                            }
                        >
                            <IconTwoSidedLineArrow />
                        </div>

                        <div
                            className={`button ${
                                activeTool === "endCapsLine" ? "active" : ""
                            }`}
                            onClick={(e) => handleShapeAdd(e, "endCapsLine")}
                        >
                            <IconTwoPointSelection />
                        </div>
                        <div
                            className={`button ${
                                activeTool === "rectangle3sided" ? "active" : ""
                            }`}
                            onClick={(e) =>
                                handleShapeAdd(e, "rectangle3sided")
                            }
                        >
                            <IconAreaSelection />
                        </div>
                        <div
                            className={`button ${
                                activeTool === "straightLine" ? "active" : ""
                            }`}
                            onClick={(e) => handleShapeAdd(e, "straightLine")}
                        >
                            <IconLine />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Shapes;
